import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function ArrowTopMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M13 6.828V21h-2V6.828l-5.364 5.364-1.414-1.414L12 3l7.778 7.778-1.414 1.414L13 6.828z"  /></Svg>;
}
export default ArrowTopMedium;